{
  "newFeature": "El conmutador de aplicaciones simplificado ahora solo incluye las aplicaciones habilitadas para usted en una sola lista.",
  "newLayout": "Diseño nuevo",
  "ok": "Aceptar"
}
